(function () {
  'use strict';

  function injectSaveBadge() {
    document.querySelectorAll('.gr-save-badge').forEach(function(n){ n.remove(); });

    var productInfo = document.querySelector('.product-information, [class*="product-details"], [data-section-type="product-information"]');
    if (!productInfo) return false;

    var saleEl    = productInfo.querySelector('.price-item--sale');
    var compareEl = productInfo.querySelector('.price-item--regular, .compare-at-price, s.price-item');

    if (!saleEl || !compareEl) return false;

    var sale    = parseFloat(saleEl.textContent.replace(/[^0-9.]/g, ''));
    var compare = parseFloat(compareEl.textContent.replace(/[^0-9.]/g, ''));

    if (!sale || !compare || compare <= sale) return false;

    var pct = Math.round((1 - sale / compare) * 100);
    if (pct < 1 || pct > 99) return false;

    var badge = document.createElement('span');
    badge.className = 'gr-save-badge';
    badge.textContent = 'SAVE ' + pct + '%';

    compareEl.parentNode.insertBefore(badge, compareEl.nextSibling);
    return true;
  }

  function debounce(fn, delay) {
    var timer;
    return function() {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  function init() {
    if (!document.querySelector('.product-information, [class*="product"]')) return;

    /* Initial badge with capped retries */
    var attempts = 0;
    var maxAttempts = 10;
    function tryBadge() {
      var ok = injectSaveBadge();
      if (!ok && attempts < maxAttempts) {
        attempts++;
        setTimeout(tryBadge, 400);
      }
    }
    tryBadge();

    /* INP fix: longer debounce + auto-disconnect after page settles */
    var root = document.querySelector('.product-information') || document.body;
    var mutationCount = 0;
    var MAX_MUTATIONS = 30;
    var debouncedBadge = debounce(function() {
      injectSaveBadge();
    }, 800);

    var mo = new MutationObserver(function(mutations) {
      mutationCount += mutations.length;
      if (mutationCount > MAX_MUTATIONS) {
        mo.disconnect();
        return;
      }
      var relevant = mutations.some(function(m) {
        return Array.from(m.addedNodes).every(function(n) {
          return !n.classList || !n.classList.contains('gr-save-badge');
        });
      });
      if (relevant) debouncedBadge();
    });
    mo.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 200);
  }
  document.addEventListener('shopify:section:load', init);

})();
